// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductPerks-module-container-3UwMH{display:flex;flex-flow:row wrap;justify-content:flex-start;align-items:center;position:relative}.ProductPerks-module-variantWrapper-2Mm3c{display:flex;flex-direction:row;justify-content:left;align-items:center;margin-inline-end:10px;margin-bottom:10px;transition:all .3s}.ProductPerks-module-variantMoreText-1l3L6{color:#5c5c5c;font-size:12px}", ""]);
// Exports
exports.locals = {
	"container": "ProductPerks-module-container-3UwMH",
	"variantWrapper": "ProductPerks-module-variantWrapper-2Mm3c",
	"variantMoreText": "ProductPerks-module-variantMoreText-1l3L6"
};
module.exports = exports;
